import fetch from "isomorphic-fetch";
import { message, setIsFetching, setCreatedTreeKey } from "../../../actions";
import Configuration from "../../../config.js";
import { setQuestions } from "./Questions";
import ReactGA from "react-ga";
import { translations } from "../../../config";

/**
 * Konstanten
 */
export const SET_BLOCK = "SET_BLOCK";
export const SET_NEXT_BLOCK_SORT_ID = "SET_NEXT_BLOCK_SORT_ID";
export const SET_BLOCKS = "SET_BLOCKS";
export const RESET_BLOCKS = "RESET_BLOCKS";

/**
 * Setter
 */
export function setBlock( questionnaire_id, json )
{
	return {
		type: SET_BLOCK,
		questionnaire_id,
		json
	};
}

export function setNextBlockSortId( sort_id )
{
	return {
		type: SET_NEXT_BLOCK_SORT_ID,
		sort_id
	};
}

export function setBlocks( questionnaire_id, json )
{
	return {
		type: SET_BLOCKS,
		questionnaire_id,
		json
	};
}

export function resetBlocks( json )
{
	return {
		type: RESET_BLOCKS,
		json
	};
}

/**
 * Zeigt den gewählten Fragebogenblock
 * @deprecated
 *
 * @param id {number}
 * @param questionnaire_id {number}
 */
export function getBlock( id, questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/blocks/${id}?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setBlock( questionnaire_id, json ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getBlock(...)

/**
 * Zeigt alle Fragebögen in der Übersicht an
 *
 * @param {number} questionnaire_id     Umfrage Id
 * @param {String} a_created_key        Angelegter Key
 */
export function getBlocks( questionnaire_id, a_created_key = null )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Block",
				action: "Blöcke mit Fragen laden"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/blocks?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setBlocks( questionnaire_id, json ) );
									
									// Fragenliste erzeugen und im State ablegen
									const questions = {};
									
									Object.keys( json ).forEach(
										( a_block_key ) =>
										{
											Object.keys( json[a_block_key].questions ).forEach(
												( a_key ) =>
												{
													questions[a_key] = { ...json[a_block_key].questions[a_key] };
													questions[a_key]["answers"] = Object.keys( json[a_block_key].questions[a_key]["answers"] )
														.sort( ( answer1, answer2 ) =>
															json[a_block_key].questions[a_key]["answers"][answer1].sort_id - json[a_block_key].questions[a_key]["answers"][answer2].sort_id
														)
														.map(
															( a_answer_key ) => json[a_block_key].questions[a_key]["answers"][a_answer_key]
														);
												}
											);
										}
									);
									
									dispatch( setQuestions( { [questionnaire_id]: questions } ) );
									
									// Wenn zuvor ein Block angelegt wurde
									if ( a_created_key )
									{
										dispatch( setCreatedTreeKey( a_created_key ) );
									}
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getBlocks(...)

/**
 * Api-Anfrage: Neuen Fragebogen erstellen
 *
 * @param block {Object}
 * @param questionnaire_id {number}
 */
export function createBlocks( block, questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Block",
				action: "Block anlegen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		// headers[ "content-type" ] = "application/json";
		
		let formData = new FormData();
		formData.append( "questionnaire_id", questionnaire_id.toString() );
		formData.append( "title", block.title );
		formData.append( "description", block.description );
		formData.append( "sort_id", block.sort_id.toString() );
		if ( block.new_sort_id )
		{
			formData.append( "new_sort_id", block.new_sort_id.toString() );
		}
		
		return fetch(
			`${Configuration.apiUrl}/admin/blocks`,
			{
				credentials: "include",
				method: "POST",
				body: formData,
				headers
			}
		)
			.then(
				response =>
				{
					// Fragebogen angelegt
					if ( response.ok )
					{
						
						// Angelegte ID merken
						response.json()
							.then( json =>
								{
									// Da es nach erfolgreicher Erstellung neue Fragebögen gibt, wird erneut die Api aufgerufen um Sie in den Store zu laden.
									dispatch( getBlocks( questionnaire_id, `menuTree-blocks-${json}` ) );
								}
							);
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( `${translations.de_DE.words.questionnaireBlock} erfolgreich angelegt.`, "info", 5000 ) );
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function createBlocks(...)

/**
 * Zeigt die nächste Sortier Id an
 * @deprecated
 *
 * @param questionnaire_id {number}
 */
export function getNextBlockSortId( questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/next-block-sort-id?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( sort_id =>
								{
									dispatch( setNextBlockSortId( sort_id ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( setNextBlockSortId( null ) );
									
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( setNextBlockSortId( null ) );
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getNextQuestionSortId(...)

/**
 * Api-Anfrage: Fragebogen bearbeiten
 *
 * @param a_formData {Object}
 * @param a_block_id {number}
 * @param a_questionnaireId {number}
 * @param a_params {string}
 */
export function patchBlocks( a_formData, a_block_id, a_questionnaireId, a_params )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Block",
				action: "Block bearbeiten"
			} );
		}
		
		const params = a_params ? "?" + a_params : "";
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${a_questionnaireId}/blocks/${a_block_id}${params}`,
			{
				credentials: "include",
				method: "PATCH",
				headers,
				body: JSON.stringify( a_formData )
			}
		)
			.then(
				response =>
				{
					// Fragebogen aktualisiert
					if ( response.ok )
					{
						// Da es nach erfolgreicher Erstellung neue Fragebögen gibt, wird erneut die Api aufgerufen um Sie in den Store zu laden.
						dispatch( getBlocks( a_questionnaireId ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						switch ( a_params )
						{
							case "sort":
								dispatch( message( "Der Block wurde verschoben.", "info", 5000 ) );
								break;
							default:
								dispatch( message( "Der Block wurde erfolgreich geändert.", "info", 5000 ) );
						}
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function patchBlocks(...)

/**
 * Api-Anfrage: Fragebogen löschen
 *
 * @param id {number}
 * @param questionnaire_id {number}
 */
export function deleteBlocks( id, questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Block",
				action: "Block mit Fragen löschen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/blocks/${id}`,
			{
				credentials: "include",
				method: "DELETE",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// Da es nach erfolgreicher Erstellung neue Fragebögen gibt, wird erneut die Api aufgerufen um Sie in den Store zu laden.
						dispatch( getBlocks( questionnaire_id ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( `${translations.de_DE.words.questionnaireBlock} erfolgreich gelöscht.`, "info", 5000 ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function deleteBlocks(...)